import React, { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { CommonColors } from "../../../../types/colors";

interface TooltipPopperProps {
  className?: string;
  color?: "default" | CommonColors;
  content?: ReactNode;
}

const STYLES = {
  default: "text-neutral-50 bg-neutral-200",
  primary: "text-neutral-50 bg-neutral-800",
  success: "text-neutral-50 bg-success-600",
  error: "text-neutral-50 bg-error-600",
  info: "text-neutral-50 bg-info-500",
  warning: "text-neutral-50 bg-warning-700",
} as const;

export function TooltipPopper({ className, color = "primary", content }: TooltipPopperProps) {
  return <div className={twMerge("sup-tooltip-popper relative shadow p-4 max-w-[17rem]", STYLES[color], className)}>{content}</div>;
}
